import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	titleText: {
		textTransform: "uppercase"
	},
	subtitleText: {
		color: "#000"
	}
})

export default useStyles
